import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import placeholderPic from "../../../assets/no_data_x.gif";
import GenericHeader from "../../../components/GenericHeader/GenericHeader";
import GenericTable from "../../../components/GenericTable/GenericTable";
import users from "../../../configs/users";
import UserService from "../../../services/Entities/UserService";
import useUrlState from "@ahooksjs/use-url-state";
import { useApiHook } from "providers/ApiProvider";
import { usePermissionChecker } from "hooks/useRoles";
import { showErrorAlert, showSuccessAlert } from "store/actions/alerts";

const UsersTableView = () => {
  const [selectedRows, setSelectedRows] = useState([]);

  const history = useHistory();
  const dispatch = useDispatch();
  const permissionChecker = usePermissionChecker();

  const [searchQuery, setSearchQuery] = useState(
    localStorage.getItem("searchQuery") || ""
  );

  const [queryParams, setQueryParams] = useUrlState({
    q: searchQuery ?? "",
    page: 0,
    pageSize: 10,
    // sortBy: "releaseDate",
    // sortDirection: "desc",
  });

  const query = {
    query_all: queryParams.q,
    page: Number(queryParams.page),
    pageSize: queryParams.pageSize,
  };

  const usersClient = new UserService();
  const usersData = useApiHook("Users", "getAllResources", { query });

  const handleSearch = (value: string) => {
    localStorage.setItem("searchQuery", value);
    setSearchQuery(value);

    if (queryParams.q !== value) {
      setQueryParams({ q: value, page: 0 });
    } else {
      setQueryParams({ q: value });
    }
  };

  const deleteUser = () => {
    if (!permissionChecker("delete-user", true)) return;

    usersClient.deleteManyResource({ data: selectedRows }).then((res) => {
      if (res?.data?.success) {
        dispatch(showSuccessAlert("User Deleted"));
        usersData.refresh();
      } else {
        dispatch(showErrorAlert(res?.data?.message));
      }
    });
  };

  const navigateToAddPage = () => {
    history.push(`users/add`);
  };

  const rowTriggerAction = (row: any) => {
    history.push(`users/${row?._id}`);
  };

  const handlePageChange = (e: any, value: any) => {
    setQueryParams({ page: value });
  };

  const handleRowsChange = (e: { target: { value: string } }) => {
    setQueryParams({ page: 0, pageSize: parseInt(e.target.value) });
  };

  const handleRowSelectionChange = (data: any) => {
    setSelectedRows(data);
  };

  return (
    <div className="container-fluid p-0">
      <GenericHeader
        selectedRows={selectedRows}
        onSearch={handleSearch}
        addResourceHandler={navigateToAddPage}
        deleteResourceHandler={deleteUser}
        model="user"
      />
      <div className="p-4">
        <h2 className="mb-4">Users</h2>
        <GenericTable
          list={usersData?.data?.data ? usersData.data.data : []}
          totalCount={usersData?.data?.total}
          onSelectedChange={handleRowSelectionChange}
          selectedRows={selectedRows}
          page={Number(queryParams.page)}
          loading={usersData.loading}
          rowsPerPage={Number(queryParams.pageSize)}
          onRowsChange={handleRowsChange}
          onPageChange={handlePageChange}
          image={placeholderPic}
          tableConfig={users}
          model="user"
          passRow={rowTriggerAction}
        />
      </div>
    </div>
  );
};

export default UsersTableView;
